import twoDigitFormat from "./two.digit.format";

function DateTimeNow() {

  const t = new Date();
  const date = `${ twoDigitFormat( t.getDate() ) }.${ twoDigitFormat( t.getMonth() + 1 ) }.${ t.getFullYear() }`;
  const time = `${ twoDigitFormat( t.getHours() ) }:${ twoDigitFormat( t.getMinutes() ) }:${ twoDigitFormat( t.getSeconds() ) }`;

  return {
    date,
    time
  };

}

function printDateTime() {

  const current = DateTimeNow();
  return `[ ${ current.date } ${ current.time } ]`;

}

export {

  DateTimeNow,
  printDateTime

}